import { AppState } from 'src/store/root-reducer';
import { getActivePanelEventId } from 'src/router/router-selectors';
import { getEventById } from 'src/forecast/forecast-selectors';

export const getActivePanelEvent = (state: AppState) => {
  const eventId = getActivePanelEventId(state) || ""
  return getEventById(eventId)(state)
}

